module.exports = __webpack_public_path__ + "static/media/tilephoto1.a5147a37.jpeg";